import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ModifyDatasourceAuthorizationForm from './form'

const ModifyDatasourceAuthorizationDialog = React.forwardRef(function ModifyDatasourceAuthorizationDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Configure Datasource Authorization'
      open={dialogState.open}
      onClose={close}
      size='large'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ModifyDatasourceAuthorizationForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ModifyDatasourceAuthorizationDialog.propTypes = {
  onComplete: PropTypes.func
}

ModifyDatasourceAuthorizationDialog.defaultProps = {
  onComplete: () => {}
}

export default ModifyDatasourceAuthorizationDialog
